// @flow

import React, {type Node, useEffect, useState} from 'react';
import styled, { css } from 'styled-components';
import { getSafePixQRCode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';

import { useCopyToClipboard } from '../../../../../uber/commons/molecules/copy-to-clipboard';
import { toDataURL as toQRCodeDataURL } from 'qrcode/lib/server';

import checkIconSrc from './white-check-icon.svg';

export function QrCodeMobile(): Node {
  return (
    <>
      <QRCodeWrapper>
        <QRCodeTitle>
          Pague com Pix
        </QRCodeTitle>
        <QRCodeSubtitle>
          Use o app de seu banco ou carteira digital para pagar usando o código QR abaixo:
        </QRCodeSubtitle>
        <CopyToClipboard />
      </QRCodeWrapper>
    </>
  );
}

function CopyToClipboard(): Node {
  const incomingPayment = usePendingIncomingPayment();

  const qrCodeValue = getSafePixQRCode(incomingPayment);
  const [qrCodeData, setQrCodeData] = useState();
  const [Clipboard, copied, handleClick] = useCopyToClipboard();

  const copyMessage = 'Copiar código Pix';
  const copiedMessage = 'Código Copiado ';

  useEffect(() => {
    (async () => {
      const data = await toQRCodeDataURL(qrCodeValue, { width: '136px', height: '136px' });
      setQrCodeData(data);
    })();
  }, [qrCodeValue]);

  return (
    <>
      <QRCodeButton
        as={Clipboard}
        onClick={handleClick}
        data-clipboard-text={getSafePixQRCode(incomingPayment)}
        copied={copied}
      >
        <QRCode src={qrCodeData} alt="qrcode"/>
      </QRCodeButton>
      <Button
        as={Clipboard}
        onClick={handleClick}
        data-clipboard-text={getSafePixQRCode(incomingPayment)}
        copied={copied}
        background={copied ? '#2ecc71' : '#2397d4'}
        block
      >
        {copied ? <>{copiedMessage} <img src={checkIconSrc} alt="check-icon"/></> : copyMessage}
      </Button>
    </>
  );
}

const QRCodeWrapper = styled.div `
  padding: 16px 32px 24px 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const QRCodeTitle = styled.div `
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
  font-family: ${props => props.theme.fontFamily.display};
`;

const QRCodeSubtitle = styled.div `
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 10px;
`;

const QRCodeButton = styled.div `
  border: none;
  margin-bottom: 10px;
  background: #fff;

  &:focus {
    outline: none;
  }
`;

const QRCode = styled.img `
  width: 158px;
  height: 158px;
`;

const Button = styled.div `
  height: 48px;
  width: 100%;
  font-weight: bold;
  text-transform: uppercase;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1);
  color: #fff;
  position: relative;

  border: none;
  border-radius: 6px;
  outline: none;

  ${({ background }) => background && css`
    background: ${background};
  `}
`;
